import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "../styles/Settings.css";
import defaultAvatar from "../assets/OIP.jpg";

const Submit = () => {
  const navigate = useNavigate();

  const storedUsername = sessionStorage.getItem("newUsername") || "YourUsername";
  const storedPassword = sessionStorage.getItem("newPassword") || "******";
  const storedEmail = sessionStorage.getItem("newEmail") || "your-email@buffalo.edu";

  const [username, setUsername] = useState(storedUsername);
  const [password, setPassword] = useState(storedPassword);
  const [email, setEmail] = useState(storedEmail);

  const handleSubmit = () => {
    sessionStorage.setItem("newUsername", username);
    sessionStorage.setItem("newPassword", password);
    sessionStorage.setItem("newEmail", email);
    
    alert(`Profile updated! \nUsername: ${username}\nPassword: ${password}\nEmail: ${email}`);
    navigate("/settings");
  };

  return (
    <div className="settings-container">
      <div className="profile-section">
        <div className="profile-header">
          <h2>{username}</h2>
          <div className="profile-info">
            <img src={defaultAvatar} alt="Profile" className="profile-picture" />
            <div className="profile-text">
              <p>XXXXX Followers</p>
              <p>XXXXX Following</p>
            </div>
          </div>
        </div>
      </div>

      <div className="settings-list">

        <Link to="/username" className="settings-item">
          <span className="settings-label"><strong>Username</strong></span>
          <span className="settings-value">{username}</span>
          <span className="settings-arrow">{">"}</span>
        </Link>

        <Link to="/password" className="settings-item">
          <span className="settings-label"><strong>Password</strong></span>
          <span className="settings-value">******</span>
          <span className="settings-arrow">{">"}</span>
        </Link>

        <Link to="/email" className="settings-item">
          <span className="settings-label"><strong>UB Email</strong></span>
          <span className="settings-value">{email}</span>
          <span className="settings-arrow">{">"}</span>
        </Link>
      </div>

      <div className="submit-container">
        <button className="submit-button" onClick={handleSubmit}>Submit</button>
      </div>
    </div>
  );
};

export default Submit;
